import brMill from "./brMill.json";
export { brMill };
// attribution: https://raw.githubusercontent.com/paulofreitas/jvectormap-brazil-map
//# sourceMappingURL=index.js.map